import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'defaultString',
})
export class DefaultStringPipe implements PipeTransform {
  transform(text: string | null, defaultValue: string = 'N/A') {
    return text && text != '' ? text : defaultValue;
  }
}
